import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private router: Router) {}

  canActivate(): boolean {
    return this.checkMaintenance();
  }

  canActivateChild(): boolean {
    return this.checkMaintenance();
  }

  canLoad(): boolean {
    return this.checkMaintenance();
  }

  private checkMaintenance(): boolean {
    if (environment.maintenanceMode) {
      this.router.navigate(['/maintenance']);
      return false;
    }
    return true;
  }
}
